<template>
  <component
    :is="filterComponent"
    v-bind="filterProps"
    :model-value="value"
		:class="{ 'filter-active': isActive }"
    @update:model-value="$emit('update:value', $event)"
  />
</template>

<script lang="ts">
import VInput from '@/lib/components/VInput/VInput.vue';
import VInputNumber from '@/lib/components/VInputNumber/VInputNumber.vue';
import VInputMask from '@/lib/components/VInputMask/VInputMask.vue';
import VSelect from '@/lib/components/VSelect/VSelect.vue';
import VDateRangeInputNew from "@/lib/components/VDateRangeInputNew/VDateRangeInputNew.vue";
import type { DataGridColumn } from './VDataGridColumnV2.vue';

const FILTER_COMPONENTS: Record<string, Component> = {
  text: VInput,
  number: VInputNumber,
  mask: VInputMask,
  select: VSelect,
  'date-range': VDateRangeInputNew,
};

export default defineComponent({
  name: 'VDataGridFilterV2',

  props: {
    column: {
      type: Object as PropType<DataGridColumn>,
      required: true,
    },
    value: {
      type: [String, Number, Object, Array] as PropType<unknown>,
      default: null,
    },
  },

  emits: ['update:value'],

  computed: {
    filterComponent(): Component {
      return FILTER_COMPONENTS[this.column.filterType] || VInput;
    },

    filterProps(): Record<string, unknown> {
      const col = this.column;
      const props = col.filterProps || {};

      const base: Record<string, unknown> = {
        textAlign: col.contentAlign,
        clearable: props.clearable !== false,
      };

      switch (col.filterType) {
        case 'text':
          return {
            ...base,
            placeholder: props.placeholder || '',
          };

        case 'number':
          return {
            ...base,
            min: props.min,
            max: props.max,
            step: props.step,
            precision: props.precision,
          };

        case 'mask':
          return {
            ...base,
            mask: props.mask,
            masked: props.masked,
            tokens: props.tokens,
          };

        case 'select':
          return {
            ...base,
            placeholder: 				props.placeholder || 'Все',
            searchable: 				props.searchable,
            multiple: 					props.multiple,
            options: 						props.options,
            optionLabel: 				props.optionLabel,
            optionIdentity: 		props.optionIdentity,
            dataUrl: 						props.dataUrl,
            minimumInputLength: props.minimumInputLength,
						searchFunction:     props.searchFunction,
          };

        case 'date-range':
          return {
            ...base,
            placeholder: props.placeholder,
            showMonths: props.showMonths,
          };

        default:
          return base;
      }
    },

		isActive(): boolean {
			const v = this.value;
			if (v === null || v === undefined || v === '') return false;
			if (Array.isArray(v)) return v.length > 0;
			return true;
		},
  },
});
</script>
